/* ==========================================================================
   Windryft — comportamiento propio
   Un unico archivo, vanilla, sin librerias. Cada init comprueba que su
   elemento existe, asi el mismo archivo vale para todas las paginas.
   ========================================================================== */

(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveals */
  function initReveals() {
    var elementos = document.querySelectorAll('.mt-reveal:not([data-mt-observed])');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('mt-visible');
        el.setAttribute('data-mt-observed', '');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('mt-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) {
      el.setAttribute('data-mt-observed', '');
      observador.observe(el);
    });
  }

  /* ------------------------------------------------------------ cifras */
  function initContadores() {
    var contadores = document.querySelectorAll('[data-mt-count]:not([data-mt-observed])');
    if (!contadores.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-mt-count'));
      if (isNaN(destino)) return;
      var decimales = (el.getAttribute('data-mt-decimals') | 0) || 0;

      if (sinMovimiento) {
        el.textContent = destino.toFixed(decimales);
        return;
      }

      var duracion = 1500;
      var inicio = null;

      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var t = Math.min((ahora - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - t, 3);
        el.textContent = (destino * suave).toFixed(decimales);
        if (t < 1) requestAnimationFrame(paso);
      }

      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      contadores.forEach(animar);
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          animar(entrada.target);
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.6 }
    );

    contadores.forEach(function (el) {
      el.setAttribute('data-mt-observed', '');
      observador.observe(el);
    });
  }

  /* ------------------------------------------------------------ parallax */
  function initParallax() {
    var capas = document.querySelectorAll('[data-mt-parallax]');
    if (!capas.length || sinMovimiento) return;

    var pendiente = false;

    function pintar() {
      pendiente = false;
      capas.forEach(function (capa) {
        var intensidad = parseFloat(capa.getAttribute('data-mt-parallax')) || 0;
        if (!intensidad) return;
        var caja = capa.parentElement.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        var avance = (window.innerHeight - caja.top) / (window.innerHeight + caja.height);
        var desplazamiento = (avance - 0.5) * intensidad;
        capa.style.transform = 'translate3d(0,' + desplazamiento.toFixed(2) + 'px,0)';
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(pintar);
      },
      { passive: true }
    );

    pintar();
  }

  /* ----------------------------------------------------------- marquesina */
  function initMarquesinas() {
    var pistas = document.querySelectorAll('.mt-marquee__track:not([data-mt-cloned])');
    pistas.forEach(function (pista) {
      pista.setAttribute('data-mt-cloned', '');
      // Duplicamos el contenido para que el bucle a -50% sea continuo.
      var original = Array.prototype.slice.call(pista.children);
      original.forEach(function (hijo) {
        var copia = hijo.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        pista.appendChild(copia);
      });
    });
  }

  /* -------------------------------------------------------------- galeria */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-gallery]:not([data-mt-ready])');
    galerias.forEach(function (galeria) {
      galeria.setAttribute('data-mt-ready', '');
      var principal = galeria.querySelector('[data-mt-gallery-main]');
      var miniaturas = galeria.querySelectorAll('[data-mt-gallery-thumb]');
      if (!principal || !miniaturas.length) return;

      miniaturas.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var url = boton.getAttribute('data-mt-src');
          if (!url) return;
          principal.src = url;
          principal.alt = boton.getAttribute('data-mt-alt') || '';
          miniaturas.forEach(function (otro) { otro.setAttribute('aria-current', 'false'); });
          boton.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ------------------------------------------------------------ variantes */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-mt-variants]:not([data-mt-ready])');
    bloques.forEach(function (bloque) {
      bloque.setAttribute('data-mt-ready', '');

      var datos = bloque.querySelector('[data-mt-variants-json]');
      var entradaId = bloque.querySelector('[data-mt-variant-id]');
      var botonAnadir = bloque.querySelector('[data-mt-add]');
      if (!datos || !entradaId) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var precio = bloque.querySelector('[data-mt-price]');
      var comparado = bloque.querySelector('[data-mt-compare-price]');
      var stock = bloque.querySelector('[data-mt-stock]');
      var textoAgotado = botonAnadir ? botonAnadir.getAttribute('data-mt-soldout-text') || 'Sold out' : '';
      var textoNormal = botonAnadir ? botonAnadir.getAttribute('data-mt-add-text') || botonAnadir.textContent.trim() : '';

      function seleccionActual() {
        var elegidas = [];
        bloque.querySelectorAll('[data-mt-option-group]').forEach(function (grupo) {
          var activo = grupo.querySelector('[aria-pressed="true"]');
          elegidas.push(activo ? activo.getAttribute('data-mt-value') : null);
        });
        return elegidas;
      }

      function aplicar() {
        var elegidas = seleccionActual();
        var encontrada = variantes.filter(function (v) {
          return elegidas.every(function (valor, i) {
            return valor === null || v.options[i] === valor;
          });
        })[0];

        if (!encontrada) return;

        entradaId.value = encontrada.id;

        if (precio) precio.innerHTML = encontrada.price;
        if (comparado) {
          comparado.innerHTML = encontrada.compare_at_price || '';
          comparado.hidden = !encontrada.compare_at_price;
        }

        if (botonAnadir) {
          botonAnadir.disabled = !encontrada.available;
          botonAnadir.textContent = encontrada.available ? textoNormal : textoAgotado;
        }

        if (stock) {
          stock.textContent = encontrada.available
            ? stock.getAttribute('data-mt-in-text') || 'In stock'
            : stock.getAttribute('data-mt-out-text') || 'Out of stock';
          stock.classList.toggle('mt-buy__stock--out', !encontrada.available);
        }
      }

      bloque.querySelectorAll('[data-mt-value]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          var grupo = boton.closest('[data-mt-option-group]');
          if (!grupo) return;
          grupo.querySelectorAll('[data-mt-value]').forEach(function (otro) {
            otro.setAttribute('aria-pressed', 'false');
          });
          boton.setAttribute('aria-pressed', 'true');
          aplicar();
        });
      });
    });
  }

  function arrancar() {
    initReveals();
    initContadores();
    initParallax();
    initMarquesinas();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: hay que reenganchar todo.
  document.addEventListener('shopify:section:load', arrancar);
})();
